import { required, email, passwordMatch } from "./formValidators";

export const registerFormFieldList = [
	{
		label: "Registration code",
		name: "unique_id",
		type: "text",
		validate: [required]
	},
	{
		label: "Email Address",
		name: "email",
		type: "text",
		validate: [required, email]
	},
	{
		label: "Password",
		name: "password",
		type: "password",
		validate: [required]
	},
	{
		label: "Confirm Password",
		name: "confirmPassword",
		type: "password",
		validate: [required, (value, values) => passwordMatch(value, values.password)]
	}
];

export const resetPasswordFormFieldList = [
	{
		label: "Password",
		name: "password",
		type: "password",
		validate: [required]
	},
	{
		label: "Password (confirm)",
		name: "confirmPassword",
		type: "password",
		validate: [required, (value, values) => passwordMatch(value, values.password)]
	}
];
